import Vue from 'vue'
import vDeleteConfirm from '../components/v-delete-confirm/index.vue'
import vDropdown from '../components/v-dropdown/index.vue'
import vIcon from '../components/v-icon/index.vue'
import vImageUpload from '../components/v-image-upload/index.vue'
import vPromiseButton from '../components/v-promise-button/index.vue'

Vue.component('v-icon', vIcon)
Vue.component('v-delete-confirm', vDeleteConfirm)
Vue.component('v-dropdown', vDropdown)
Vue.component('v-image-upload', vImageUpload)
Vue.component('v-promise-button', vPromiseButton)
